import React from 'react';
import DumbMarkdown from 'markdown-to-jsx';
import { Link } from '@tribeplatform/react-ui-kit/Link';
export const MarkdownBlock = ({ text }) => {
    return (React.createElement("article", null,
        React.createElement(DumbMarkdown, { options: {
                overrides: {
                    a: {
                        component: Link,
                        props: {
                            external: true,
                        },
                    },
                    li: {
                        component: 'li',
                        props: {
                            className: 'list-disc list-outside ps-6',
                        },
                    },
                },
            } }, text)));
};
//# sourceMappingURL=Block.js.map